module.exports = __webpack_public_path__ + "img/home-hero-img-sm.e6fb5fb2.svg";